import { userStore, types } from "@/BaseComponent";
import { apiService, header } from "@/services/interceptor";
import { ReqBoardApplyList } from "@/types";
import { AxiosResponse } from "axios";

export default {
    async list(): Promise<types.ResBoardActionStateList> {
        let res = {} as types.ResBoardActionStateList;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/state/list", null, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },

    async modify(idx: number): Promise<types.BaseResponse> {
        let res = {} as types.BaseResponse;
        try {
            header.headers["Content-Type"] = "application/json";
            const response = await apiService().post("/board/action/state/modify/" + idx, { withCredentials: false });

            return response.data;
        } catch (error: any) {
            console.error(error);
            res = error.response.data;
        }
        return res;
    },
};
